import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { BoxProps } from '@osmosis/react-ui/components/Box';
import { getTextColor } from '../../../lib/composer/schemas/theme';
import { textColorClassMap, textGray } from '@osmosis/tailwind-ui/styles/text';

type Props = {
  html: string;
  alignment?: 'center' | 'left' | 'right';
  theme?: string;
  containerProps?: BoxProps;
};

/**
 * Rich text block element.
 */
const RichText = (props: Props) => {
  const {
    html = '',
    theme = 'transparent',
    alignment = 'left',
    containerProps = {}, // ADD IN CUSTOM CONTAINER PROPS
  } = props;

  const textColor = getTextColor(theme);
  const textColorClass = textColorClassMap[textColor] || textGray;

  return (
    <Box
      {...containerProps}
      className={`${containerProps.className || ''} ${textColorClass}`}
      sx={{
        margin: alignment === 'center' ? 'auto' : '',
        textAlign: alignment,
        a: {
          color: 'primaryText',
          textDecoration: 'none',
        },
        maxWidth: 450,
        ...containerProps.sx,
      }}
    >
      <Box dangerouslySetInnerHTML={{ __html: html }} />
    </Box>
  );
};

export default RichText;
